import { gql } from '@apollo/client';

import { GET_RMA_ORDER_OPERATION } from 'utils/constants';

export const LIST_RMA_ORDERS = gql`
  query ${GET_RMA_ORDER_OPERATION}($accountId: ID!, $salesOrderNumber: ID!) {
    getAccount(accountId: $accountId) {
      accountId
      getRmaOrder(salesOrderNumber: $salesOrderNumber) {
        currencyCode
        lines {
          partNumber
          partDescription
          lineId
          lineType
          lineStatus
          actualShipDate
          trackingNumber
          trackingNumberURL
          shippingMethod
          scheduledShipDate
          serialNumbers
          extendedSellPrice
          manualAssignmentLine
        }
      }
    }
  }
`;
